import React, { useEffect, useState } from 'react';
import { Pie } from '@ant-design/plots';
import styled from '@emotion/styled';
import COLORS from 'common/Colors';
import { Spin } from 'antd';
import { concat, chain, groupBy, toPairs, zipObject, map, includes, filter } from 'lodash';
// Redux
import { connect } from 'react-redux';
import {
  getLocations,
  getUserRoleId,
  getSelectedDepartmentId,
  getClientid
} from 'redux/selectors';

import { CALL_API } from 'common/API';
import { size } from 'lodash';
import LocationBasedAttendanceList from './LocationBasedAttendanceList';

const StyledTitle = styled.div`
  font-size: 0.9rem;
  font-weight: bold;
  color: #141414;
  margin-bottom: 10px;
`;

const StyledChartContainer = styled.div`
  border: solid 1px #9B9B9B;
  height: 490px;
  border-radius: 3px;
  padding: 5px;
  margin-bottom: 20px;
  .name-title {
    padding: 3px 10px;
    font-size: 1rem;
    
  }
`;

function LocationBasedPresentStaff({
  locationList,
  userRoleId,
  selectedDepartmentId,
  ClientId
}) {
  const [displayReportLoader, toggleReportLoader] = useState(false);
  const [reportData, setReportData] = useState([]);
 
  const [reportList, setReportList] = useState([]);
  const [locationName, setLocationName] = useState('');
  const [displayAttendanceStaffModal, toggleDisplayAttendanceStaffModal] = useState(false);

  const getReportData = async () => {
    toggleReportLoader(true);
    if(ClientId){
      const delay = (ms) => new Promise((resolve) => setTimeout(resolve, ms));
    await delay(100);
    const {locationList} = await CALL_API(`location-list/${ClientId}`, 'post', {
      "departmentId": (userRoleId != 6 || userRoleId != 1) ? selectedDepartmentId : [''], 
    });
      let result = chain(locationList)
        .groupBy(x => x.loginLocationName)
        .map((value, key) => ({ loginLocationName: key, prensentList: value, presentCount: size(value) }))
        .value();
        
      setReportData(result)
     

toggleReportLoader(false);
  }
  }
  useEffect(() => {
    getReportData();
  }, [selectedDepartmentId]);
  const config = {
    // height:350,
    padding: 'auto',
    data: reportData,
    angleField: "presentCount",
    colorField: 'loginLocationName',
    radius: 0.7,
    label: {
      type: 'inner',
      offset: '-30%',
      autoRotate: false,
      // content: ({ percent }) => `${(percent * 100).toFixed(0)}%`,
      style: {
        fontSize: 12,
        textAlign: 'center',
      },
    },
    legend: {
      position: 'right',
      layot: 'vertical',
      offsetX : -30,
      itemName: {
        // formatter: (text,item) => {
        //   return " hi all the user interface check nterface"
        // },
        style:{
          fontSize: 11,
        },
      },
    },
    interactions: [
      {
        type: 'element-active',
      },
    ],
  };



  return (
    <>
      <Spin spinning={displayReportLoader}>
        <StyledTitle>LOCATION BASED PRESENT STAFF OVERVIEW</StyledTitle>
        <StyledChartContainer>
          <div className='name-title'>Today's Report:</div>
          {reportData?.length > 0 ? <>
            <Pie {...config}
              onEvent={(plot) => {
                plot.on('element:click', (x) => {
                  setLocationName(x.data.data.loginLocationName)
                  setReportList(x.data.data.prensentList)
                  toggleDisplayAttendanceStaffModal(true)
                });
              }}

            />
          </> : (
            <p style={{ height: '100%', display: 'flex', justifyContent: 'center', alignItems: 'center' }}>No Staff Present</p>
          )}
        </StyledChartContainer>
      </Spin>
      <LocationBasedAttendanceList
        displayModal={displayAttendanceStaffModal}
        toggleModal={() => toggleDisplayAttendanceStaffModal(false)}
        title={locationName}
        list={reportList}
        reportType={locationName}
      />
    </>
  );
}

const mapStateToProps = state => ({
  locationList: getLocations(state),
  userRoleId: getUserRoleId(state),
  selectedDepartmentId: getSelectedDepartmentId(state),
  ClientId: getClientid(state),
});

export default connect(mapStateToProps, null)(LocationBasedPresentStaff);